export const defaultMaxSize = 33554432;
export const defaultAcceptedExtensions = [
  ".gif",
  ".png",
  ".PNG",
  ".jpeg",
  ".jpg",
  ".svg",
  ".pdf",
  ".docx",
  ".doc",
  ".xls",
  ".xlsx",
  ".csv",
  ".ppt",
  ".pptx",
  ".txt",
  ".msg",
];
